@if (isActiveThread) {
  <app-active-thread [resource]="resource"></app-active-thread>
}

@if (isResolvedThread) {
  <app-resolved-thread [resource]="resource"></app-resolved-thread>
}

@if (isThreadCreation) {
  <app-thread-creation [resourceToCreateThreadFor]="resource"></app-thread-creation>
}
